import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewContainerRef,
  ViewEncapsulation,
  ViewChild
} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import { Router, ActivatedRoute, ParamMap, Params, NavigationStart, NavigationEnd } from '@angular/router';

import { RequestsServices } from '../../../services/requests.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { PageBase } from '../../../page.base';
import { ToasterService } from '../../../services/toaster.service';
import { TranslateService } from '@ngx-translate/core';
import { HeaderMenuComponent } from '../../../components/header-menu/header-menu.component';
import { CropperComponent } from '../../../directives/cropper/cropper.component';
import { base64toBlob } from '../../../utils/images';


@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  providers: [ RequestsServices, StorageService, UserService ],
  encapsulation: ViewEncapsulation.None
})

export class LogoComponent extends PageBase implements OnInit {

  public establishment: any = {
    image: {
      cover: '',
      gallery : {
          images : [],
          size : 4
      },
      logo: '',
    }
  };

  @ViewChild('crop') public cropper: CropperComponent;
  @ViewChild('cropCover') public cropperCover: CropperComponent;
  @ViewChild('cropGallery1') public cropperGallery1: CropperComponent;
  @ViewChild('cropGallery2') public cropperGallery2: CropperComponent;
  @ViewChild('cropGallery3') public cropperGallery3: CropperComponent;
  @ViewChild('cropGallery4') public cropperGallery4: CropperComponent;

  public isLoading;

  constructor(private translate: TranslateService,
    private toaster: ToasterService,
    private request: RequestsServices,
    private route: ActivatedRoute,
    private router: Router,
    private storage: StorageService,
    private userService: UserService) {

    super();

    let languageCurrent = navigator.language;
    translate.addLangs(['en', 'pt-br']);
    translate.setDefaultLang('en');
    languageCurrent === 'pt-BR' ? translate.use('pt-br') : translate.use('en');
  }

  public ngOnInit(): void {
    window.scrollTo(0, 0);

    const establishmentAccount = this.userService.getLoggedAccount();
    const typeBusiness = this.userService.getTypeAccount();
    if (typeBusiness === 'establishment' && establishmentAccount) {
      this.getestablishment(establishmentAccount['id']);
    } else {
      this.toaster.error('Aviso!', 'Conta de negócio inválida', false, 4000);
      this.router.navigate(['/home']);
    }
  }

  public getImageGallery(event, index): void {
    if (!event) {
       return;
    }

    let blob;
    switch (index) {
      case 0:
          blob = this.cropperGallery1.crop();
          break;
      case 1:
          blob = this.cropperGallery2.crop();
          break;
      case 2:
          blob = this.cropperGallery3.crop();
          break;
      case 3:
          blob = this.cropperGallery4.crop();
          break;
    }

    this.establishment['image']['gallery']['images'][index] = blob;
    this.saveImageAndUrlGallery(true, index);
  }


  public createPicItems($number) {
    let items: number[] = [];
    for (let i = 1; i <= $number; i++) {
      items.push(i);
    }
    return items;
  }

  private transformFildsNamesToApi(): Object {
    return this.establishment;
  }

  private getestablishment(establishmentId): void {
    this.request.get({path: 'establishments', pathParam: `/${establishmentId}`}).then((establishment) => {
      this.establishment = establishment;
    });
  }

  public getImageLogo(event): void {
    if (!event) {
       return;
    }

    let blob = this.cropper.crop();
    this.establishment['image']['logo'] = blob;
    this.saveImageAndUrlLogo(true);
  }

  public getImageCover(event): void {
    if (!event) {
       return;
    }

    let blob = this.cropperCover.crop();
    this.establishment['image']['cover'] = blob;
    this.saveImageAndUrlCover(true);
  }

  private saveImageAndUrlLogo(isUpdateImage: boolean): void {

    let imgBase64 = this.establishment['image']['logo'];

    if (isUpdateImage) {
      if (imgBase64 && imgBase64 !== '') {
        let blob = base64toBlob(imgBase64);
        let formData = new FormData();
        const timeNow = Date.now().toString();
        formData.append('image', blob, this.establishment['id'] + '-' + timeNow + '-logo');

        this.isLoading = true;
        this.request.post('storage', formData, 'upload').then((response) => {
          this.establishment.image.logo = response.result.files.image[0].providerResponse.location;
          this.request.put('establishments', this.establishment).then((establishment) => {
            this.isLoading = false;
          });
        });
      } else {
        // Reset logo image
        this.establishment['image']['logo'] = null;
        this.request.put('establishments', this.establishment).then((establishment) => {
          this.isLoading = false;
        });
      }
    }

  }

  private saveImageAndUrlCover(isUpdateImage: boolean): void {

    let imgBase64 = this.establishment['image']['cover'];

    if (isUpdateImage) {
      if (imgBase64 && imgBase64 !== '') {
        let blob = base64toBlob(imgBase64);
        let formData = new FormData();
        const timeNow = Date.now().toString();
        formData.append('image', blob, this.establishment['id'] + '-' + timeNow + '-cover');

        this.isLoading = true;
        this.request.post('storage', formData, 'upload').then((response) => {
          this.establishment.image.cover = response.result.files.image[0].providerResponse.location;
          this.request.put('establishments', this.establishment).then((establishment) => {
            this.isLoading = false;
          });
        });
      } else {
        // Reset cover image
        this.establishment['image']['cover'] = null;
        this.request.put('establishments', this.establishment).then((establishment) => {
          this.isLoading = false;
        });
      }
    }

  }

  private saveImageAndUrlGallery(isUpdateImage: boolean, index): void {

    let imgBase64 = this.establishment['image']['gallery']['images'][index];

    if (isUpdateImage) {
      if (imgBase64 && imgBase64 !== '') {

        const blob = base64toBlob(imgBase64);

        const formData = new FormData();
        formData.append('image', blob, Date.now().toString());
        this.isLoading = true;
        this.request.post('storage', formData, 'upload').then((response) => {
          let gallery = [];
          gallery[index] = response.result.files.image[0].providerResponse.location;
          this.establishment['image']['gallery']['images'][index] = gallery[index];

          this.request.put('establishments', this.establishment).then((establishment) => {
            this.isLoading = false;
          });
        });

      } else {
        // Reset image for gallery
        this.isLoading = true;
        this.establishment['image']['gallery']['images'][index] = null;
        this.request.put('establishments', this.establishment).then((establishment) => {
          this.isLoading = false;
        });
      }
    }

  }

  private clearLogoImage(): void {
    this.cropper.reset();
    this.establishment['image']['logo'] = '';
    this.saveImageAndUrlLogo(true);
  }

  private clearCoverImage(): void {
    this.cropperCover.reset();
    this.establishment['image']['cover'] = '';
    this.saveImageAndUrlCover(true);
  }

  private clearImageGallery(index): void {

    switch (index) {
      case 0:
          this.cropperGallery1.reset();
          break;
      case 1:
          this.cropperGallery2.reset();
          break;
      case 2:
          this.cropperGallery3.reset();
          break;
      case 3:
          this.cropperGallery4.reset();
          break;
    }

    this.establishment['image']['gallery']['images'][index] = '';
    this.saveImageAndUrlGallery(true, index);
  }

}
